export const isBlank = text => !text || !text.trim();
